import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowForward } from "react-icons/io";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { handleLoading } from "../../store/actions/loadingAction";
import { addBalanceToUser } from "../../store/actions/balancesActions";
import sendNotification from "../../customFunction/sendNotification";
import useSWR from "swr";
import { Error, fetcher, Loading } from "../../components/UI/TableView/ShowPaginationData";
import CoursePriceCalculationModal from "../../components/Course/CoursePriceCalculationModal";
const smalltalk = require("smalltalk");

export default function CompleteBalanceScreen() {
  const history = useHistory();
  const currentUser = useSelector((state) => state.users.currentUser);
  const balanceId = useLocation().search.split("=")[1];
  const { data: currentBalance, error, isLoading } = useSWR('/balances?_id='+balanceId, fetcher)
  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })

  const onChangeModal = (pck = {}) => {
    setPriceModal(prev => ({ ...prev, show: !prev.show, data: { ...currentBalance[0], iqd: currentBalance[0].value } }))
  }

  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  const onSubmitt = () => {
    const pD = { ...priceModal.paymentDetails, payedType: priceModal.payedType, changeType: priceModal.changeType }
    onSubmit({ ...priceModal.data, paymentDetails: pD })
    setPriceModal(prev => ({ ...prev, show: false, }))
  }
  const onSubmit = async (paymentDetails) => {
    try {
      handleLoading();
      await addBalanceToUser(currentUser, { ...currentBalance[0], paymentDetails });
      history.replace("/users");
      handleLoading();
      sendNotification({ type: 1, bioStarID: currentUser.bioStarID, title: `${currentBalance[0].value}IQD added ✅`, body: ``, data: {} });
    } catch (e) {
      console.log(e) 
      smalltalk.alert("", "ببورە هەڵەیەک ڕوویدا تکایە هەوڵبەورەوە");
    }
  };

  if (isLoading) {
    return <Loading />
  }
  if (error||!currentBalance[0]) {
    return <Error />
  }

  return (
    <div className='flex flex-col items-center w-full '>
      <CoursePriceCalculationModal onSubmit={onSubmitt} floor onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />

      <Container onSubmit={onChangeModal} />
    </div>
  );
}

const Container = ({ onSubmit }) => {
  return (
    <div className='w-4/5 mt-8 border'>
      <InputContainer />

      <SubmitButton onSubmit={onSubmit} />
    </div>
  );
};

const InputContainer = ({ currentUser }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{ backgroundColor: "#F7F7F7" }}
      className='items-center justify-center py-24'>
      <div className='flex flex-col items-center justify-center w-full '>
        <img
          src='https://cliply.co/wp-content/uploads/2021/03/372103860_CHECK_MARK_400px.gif'
          className='h-40 w-60'
          alt=""
        />
        <h1 className='text-2xl opacity-50'>{t("pleaseClickSubmit")}</h1>
      </div>
    </div>
  );
};

const SubmitButton = ({ onSubmit }) => {
  const { t } = useTranslation();

  return (
    <button
      className='flex flex-row items-center justify-end w-full p-3 cursor-pointer bg-mainAqwaBlue hover:opacity-80'
      onClick={onSubmit}>
      <h1 className='mr-1 font-bold text-white'>{t("submit")}</h1>
      <IoIosArrowForward color='#fff' />
    </button>
  );
};
